import React, { useState, useRef, useEffect } from "react";
import {
  Form,
  Input,
  FormInstance,
  Cascader,
  TreeSelect,
  Spin,
  Space,
  Button,
  Row,
  Col,
  Upload,
  notification, Select,
  Radio
} from "antd";
import { RootStoreModel } from "@redux/reducers";
import { UploadChangeParam } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";
import { useSelector } from "react-redux";
import { updateAndroidAppGetInfo,updateMacAppGetInfo } from "../../axios/api.app";
import { UploadOutlined, InboxOutlined } from "@ant-design/icons";

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";

const { Item, List } = Form;

interface propsModel {
  status: number;
  onLoad(ref: FormInstance<any>): void;

}

export const AppForm = (props: propsModel) => {

  const [form] = Form.useForm();
  const [imageUrl, setImageUrl] = useState<any>();
  const [platform, setPlatform] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const { status, onLoad } = props;
  const [logoFileType, setLogoFileType] = useState<string>('Upload');
  const [packageFileType, setPackageFileType] = useState<string>('Upload');



  const { t } = useTranslation();

  // const [appProps,setAppProps]=useState<any>({});
  // const account = useSelector(
  //   (store: RootStoreModel) => store.userState.userInfo
  // );

  useEffect(() => {
    onLoad(form);
    if (status == 1) {
      setImageUrl(form.getFieldValue("logoUrl"));
      setLogoFileType(form.getFieldValue("logoFileType"));
      setPackageFileType(form.getFieldValue("packageFileType"));
    }
    // setAppProps(updateAndroidAppGetInfoprops(account.id_token))
  }, []);

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  function getBase64(img: any, callback: any) {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      callback(reader.result);
      console.log(reader);
    });
    reader.readAsDataURL(img);
  }
  const beforeUpload = (file: File) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      notification.error({ message: t("You can only upload JPG/PNG file!") });
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      notification.error({ message: t("Image must smaller than 2MB!") });
    }
    // return isJpgOrPng && isLt2M;
    return false;
  };
  const doImgUpload = (options: any) => {
    const { file } = options;
    if (file.name.endsWith(".pkg")) {
      updateMacAppGetInfo(
        { AppPackage: file }, 
        (ev) => {
          const percent = ((ev.loaded / ev.total) * 100) | 0;
          options.onProgress({ percent: percent }, file);
        }
      ).then(
        c => {
          options.onSuccess({objectID: c.id, name: file.name}, file);
          var res = form.getFieldsValue();
          res.packageName = c.packageName;
          res.version = c.version;
          res.versionCode = c.versionCode;
          form.setFieldsValue(res);
        }, 
        () => {
          notification.error({ message: t("上传失败") })
        }
      )
    } else {
    
    updateAndroidAppGetInfo(
      { AppPackage: file },
      (ev) => {
        const percent = ((ev.loaded / ev.total) * 100) | 0;
        options.onProgress({ percent: percent }, file);
      }
    ).then(
      c => {
        options.onSuccess({objectID: c.id, name: file.name}, file);
        var res = form.getFieldsValue();
        res.packageName = c.packageName;
        res.version = c.version;
        res.versionCode = c.versionCode;
        form.setFieldsValue(res);
      }, 
      () => {
        notification.error({ message: t("上传失败") })
      })
    }
  };

  const beforeUpload2 = (file: File) => {
    const isAPK = file.type === "application/vnd.android.package-archive";
    /*  if (!isAPK) {
      notification.error({ message: "You can only upload APK file!" });
    } */
    const isLt2M = file.size / 1024 / 1024 < 200;
    if (!isLt2M) {
      notification.error({ message: t("Package must smaller than 200MB!") });
    }
    // return isJpgOrPng && isLt2M;
    return false;
  };

  const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
    getBase64(info.file, (imageUrl: any) => {
      setImageUrl(imageUrl);
      setLoading(false);
    });
  };

  const handleChangeApk = (info: UploadChangeParam<UploadFile<any>>) => {
    console.log(info)
    // updateAndroidAppGetInfo(
    //   {AppPackage:info.file}
    // ).then(c=>{

    //   console.log("updateAndroidAppGetInfo",c)
    //   var res =form.getFieldsValue();
    //   res.packageName=c.packageName;
    //   res.version=c.version;
    //   res.versionCode=c.versionCode;
    //   form.setFieldsValue(res);
    // },()=>{
    //   notification.error({message:"上传失败"})
    // })
  };
  return (
    <>
      <Spin spinning={loading}>
        <Form
          layout="horizontal"
          form={form}
          labelCol={{ span: i18n.language === "zh" ? 4 : 6 }}
          initialValues={{ tags: [], packageFileType: 'Upload', logoFileType: 'Upload' }}
        >
          <Item label={<span>&nbsp;</span>} name="packageFileType" colon={false}>
            <Radio.Group onChange={(e)=>{setPackageFileType(e.target.value)}}>
              <Radio value="Upload">上传文件</Radio>
              <Radio value="Url">文件链接</Radio>
            </Radio.Group>
          </Item>
          { packageFileType == 'Upload' && <Item
            // style={{ display: (status == 0 ? "" : "none") }}
            label={t("应用文件")}
            name="appPackage"
            rules={[{ required: status === 0 }]}
            valuePropName="fileList"
            getValueFromEvent={normFile}
            extra={t("支持apk，pkg、dmg和企业签名的ipa格式，文件不大于500MB")}
          >
            <Upload
              accept=".apk,.ipa,.pkg,.dmg"
              customRequest={doImgUpload}
              listType="text"
              showUploadList={true}
              onChange={handleChangeApk}
              maxCount={1}
            >
              <Button icon={<UploadOutlined />}>+ {t("点击上传")} </Button>
            </Upload>
          </Item>
          }
          { packageFileType == 'Url' && 
          <Item
            label={t("文件链接")}
            name="packageUrl"
            rules={[{ required: true }]}
          >
            <Input></Input>
          </Item>
          }
          <Item label={t("包名")} name="packageName" rules={[{ required: true }]}>
            <Input></Input>
          </Item>
          <Item label={t("版本")} name="version" rules={[{ required: true }]}>
            <Input></Input>
          </Item>
          <Item
            label={t("版本号")}
            name="versionCode"
            rules={[{ required: true }]}
          >
            <Input></Input>
          </Item>
          <Item label={t("应用名称")} name="name" rules={[{ required: true }]}>
            <Input></Input>
          </Item>
          <Item label={t("简介")} name="description" rules={[{ required: true }]}>
            <Input></Input>
          </Item>
          {/* <Item name="logoUrl" style={{ display: "none" }}>
            <Input></Input>
          </Item> */}
          <Item label={<span>&nbsp;</span>} name="logoFileType" colon={false}>
            <Radio.Group onChange={(e)=>{setLogoFileType(e.target.value)}}>
              <Radio value="Upload">上传文件</Radio>
              <Radio value="Url">文件链接</Radio>
            </Radio.Group>
          </Item>
          { logoFileType == 'Upload' && 
          <Item
            label={t("应用图标")}
            name="logo"
            rules={[{ required: status === 0 }]}
            valuePropName="fileList"
            getValueFromEvent={normFile}
            extra={t("不大于1MB,尺寸512px*512px")}
          >
            <Upload
              maxCount={1}
              listType="picture-card"
              accept=".png"
              showUploadList={false}
              beforeUpload={beforeUpload}
              onChange={handleChange}
            >
              {imageUrl ? (
                <img src={imageUrl} alt="avatar" style={{ width: "100%" }} />
              ) : (
                "+"
              )}
            </Upload>
          </Item>}
          { logoFileType == 'Url' && 
          <Item
            label={t("Logo链接")}
            name="logoUrl"
            rules={[{ required: true }]}
          >
            <Input></Input>
          </Item>
          }
          <Item label={t("状态")} name="status" rules={[{ required: true }]}>
            <Select>
              <Select.Option value="Active">{t("开启")}</Select.Option>
              <Select.Option value="Disabled">{t("关闭")}</Select.Option>
            </Select>
          </Item>

        </Form>
      </Spin>
    </>
  );
};
